import React from "react";
import { Link } from "react-router-dom";


function RechargeNavbar() {
  return (
    <>
      <div className="text-start text-white mb-3">
        <Link
          className="btn3 me-2 txt71 text-white"
          to="/agent/recharge"
          data-discover="true"
        >
          Prepaid Recharge
        </Link>
        <Link
          className="btn3 me-2 txt71 text-white"
          to="/agent/money-transfer"
          data-discover="true"
        >
          Money Transfer
        </Link>

        <Link
          className="btn3 me-2 txt71 text-white"
          to="/agent/credit-card-bill"
          data-discover="true"
        >
          Credit Card Bill Payment
        </Link>


        <Link
          className="btn3 me-2 txt71 text-white"
          to="/agent/dth-recharge"
          data-discover="true"
        >
          DTH Recharge
        </Link>


  
      </div>
    </>
  );
}

export default RechargeNavbar;
